import { IFieldSelect } from "@interfaces/select";
import WarehouseAPI from "@network/api/warehouse";
import { ObjectUtils, Select } from "d-react-components";
import { debounce, isArray, isEmpty, map, uniqBy } from "lodash";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

export interface IWarehouseSelect<T> extends IFieldSelect<T> {
  [key: string]: any;
  chainIds?: string[];
}

const WarehouseSelect = ({
  value = [],
  multiple,
  className,
  onChange,
  showLabel = true,
  ...selectProps
}: IWarehouseSelect<any>) => {
  const [warehouseList, setWarehouseList] = useState(
    isArray(value) ? value : [value]
  );

  const { t } = useTranslation();

  const onChangeValue = (id: any) => {
    if (multiple) {
      onChange(
        map(id, (item) => ObjectUtils.findItemFromId(warehouseList, item))
      );
      return;
    }
    onChange(ObjectUtils.findItemFromId(warehouseList, id));
  };

  const getWarehouseValue = useMemo(() => {
    if (multiple) {
      return map(value, (item: any) => item.id);
    }
    return (value as any)?.id;
  }, [value]);

  const onChangeTextSearch = debounce((textSearch) => {
    if (isEmpty(textSearch)) {
      setWarehouseList([]);
    } else {
      const body = {
        search: textSearch,
      };
      WarehouseAPI.list({ pageIndex: 1, pageSize: 100 }, body).then(
        (res: any) => {
          const warehouses = res?.data?.data?.warehouse ?? [];

          const selectedValue = isArray(value) ? value : [value];
          const filterWarehouse = map(
            [...selectedValue, ...warehouses],
            (item) => ({
              id: item.id,
              name: item.name,
            })
          );
          const uniqWarehouse = uniqBy(filterWarehouse, (item) => item.id);
          setWarehouseList(uniqWarehouse);
        }
      );
    }
  }, 500);

  return (
    <Select
      onSearch={onChangeTextSearch}
      className={className}
      label={showLabel ? t("warehouse") : ""}
      dataSource={warehouseList}
      getLabel={(item) => item?.name}
      value={getWarehouseValue}
      onChange={onChangeValue}
      multiple={multiple}
      placeholder={t("pleaseSelect")}
      showSearch
      filterOption={false}
      {...selectProps}
    />
  );
};

export default WarehouseSelect;
